import React from 'react';
import PropTypes from 'prop-types';

import Spinner from './Spinner';

const colorCodes = {
  success: '#36B37E',
  primary: '#0052CC',
  danger: '#DE350B',
  secondary: '#505F79',
};

const activeIntentObj = {
  success: 'bg-success-active text-white hover:bg-success-focus',
  error: 'bg-danger-active text-white hover:bg-danger-focus',
  primary: 'bg-primary-active text-white hover:bg-primary-focus',
  secondary: 'bg-secondary-active text-white hover:bg-secondary-focus',
};
const inactiveIntentObj = {
  success: 'bg-success-active cursor-not-allowed opacity-50 text-white',
  error: 'bg-danger-active cursor-not-allowed opacity-50 text-white',
  primary: 'bg-primary-active cursor-not-allowed opacity-50 text-white',
  secondary: 'bg-secondary-active cursor-not-allowed opacity-50 text-white',
};

const Button = ({
  children,
  loading,
  showSpinner,
  intent,
  customClass,
  isRounded,
  disable,
  onClick,
  extendClass,
  type,
}) => {
  const getActiveIntent = () => {
    switch (intent) {
      case 'success':
        return activeIntentObj.success;
      case 'error':
        return activeIntentObj.error;
      case 'danger':
        return activeIntentObj.error;
      case 'primary':
        return activeIntentObj.primary;
      case 'secondary':
        return activeIntentObj.secondary;
      default:
        return activeIntentObj.primary;
    }
  };

  const getDisabledIntent = () => {
    switch (intent) {
      case 'success':
        return inactiveIntentObj.success;
      case 'error':
        return inactiveIntentObj.error;
      case 'danger':
        return inactiveIntentObj.error;
      case 'primary':
        return inactiveIntentObj.primary;
      case 'secondary':
        return inactiveIntentObj.secondary;
      default:
        return inactiveIntentObj.primary;
    }
  };

  const applyActiveIntent = getActiveIntent();
  const applyDisableIntent = getDisabledIntent();
  const circular = isRounded ? ' rounded-md' : '';

  let classStr = customClass
    ? customClass
    : ' px-2 py-1 sm:px-4 sm:py-2 text-sm lg:text-base focus:outline-none';

  classStr = extendClass
    ? extendClass +
      ' px-2 py-1 sm:px-4 sm:py-2 text-sm lg:text-base focus:outline-none'
    : classStr;

  return (
    <React.Fragment>
      {loading === true ? (
        showSpinner ? (
          <button
            className={` ${
              classStr + ' ' + applyDisableIntent + ' ' + circular
            }`}
            type={type}
            disabled={true}
          >
            <div className="flex items-center">
              <Spinner
                extendClass={classStr}
                loaderSize={'xs'}
                color={'#fff'}
              />
              <span className="ml-2">{children}</span>
            </div>
          </button>
        ) : (
          <button
            className={` ${
              classStr + ' ' + applyDisableIntent + ' ' + circular
            }`}
            type={type}
            disabled={true}
          >
            {children}
          </button>
        )
      ) : disable === true ? (
        <button
          className={` ${classStr + ' ' + applyDisableIntent + ' ' + circular}`}
          type={type}
          disabled={true}
        >
          {children}
        </button>
      ) : (
        <button
          className={`${classStr + ' ' + applyActiveIntent + ' ' + circular}`}
          disabled={false}
          type={type}
          onClick={onClick}
        >
          {children}
        </button>
      )}
    </React.Fragment>
  );
};

Button.defaultProps = {
  disable: false,
  isRounded: true,
  loading: false,
  intent: 'primary',
  type: 'button',
  onClick: () => {},
};

Button.propTypes = {
  disable: PropTypes.bool,
  isRounded: PropTypes.bool,
  loading: PropTypes.bool,
  showSpinner: PropTypes.bool,
  children: PropTypes.any,
  intent: PropTypes.string,
  customClass: PropTypes.string,
  extendClass: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
